import { cUtil } from "../../functions/util";

export class cAccount {
  html        = document.querySelector('html')                         as HTMLHtmlElement;
  form        = document.querySelector('.woocommerce-EditAccountForm') as HTMLFormElement;
  div_contact = document.createElement('div');
  h2_contact  = document.createElement('h2');

  div_firstName    = document.createElement('div');
  label_firstName  = document.createElement('label');
  input_firstName  = document.createElement('input');
  div_firstNameErr = document.createElement('div');

  div_lastName    = document.createElement('div');
  label_lastName  = document.createElement('label');
  input_lastName  = document.createElement('input');
  div_lastNameErr = document.createElement('div');

  div_phone    = document.createElement('div');
  label_phone  = document.createElement('label');
  input_phone  = document.createElement('input');
  div_phoneErr = document.createElement('div');

  div_email    = document.createElement('div');
  label_email  = document.createElement('label');
  input_email  = document.createElement('input');
  div_emailErr = document.createElement('div');
  div_emailTxt = document.createElement('div');

  div_fun    = document.createElement('div');
  label_fun  = document.createElement('label');
  select_fun = document.createElement('select');
  option_f0  = document.createElement('option');
  option_f1  = document.createElement('option');
  option_f2  = document.createElement('option');
  option_f3  = document.createElement('option');
  option_f4  = document.createElement('option');
  option_f5  = document.createElement('option');
  option_f6  = document.createElement('option');
  div_funErr = document.createElement('div')

  button_delete  = document.createElement('button');
  p_warning      = document.createElement('p');
  button_confirm = document.createElement('button');
  button_cancel  = document.createElement('button');
  input_data     = document.createElement('input');

  input_wcFirstName = document.querySelector('#account_first_name') as HTMLInputElement;
  input_wcLastName  = document.querySelector('#account_last_name')  as HTMLInputElement;
  div_wcEmail       = document.querySelector('.woocommerce-form-row:has(#account_email)')
  
  script      = document.querySelector('.c-account-details-data script')             as HTMLScriptElement;

  parent      = document.querySelector('.c-delete-account')                          as HTMLElement;
  button_pw   = document.querySelector('.c-change-pw')                               as HTMLButtonElement;
  fieldset_pw = document.querySelector('fieldset:has(.woocommerce-Input--password)') as HTMLElement;
  button_save = document.querySelector('button[name="save_account_details"]')        as HTMLButtonElement;

  nonce = '';
  data : AccountDetails = {phone: '', function: '', email: '', managedInStatus: false};

  constructor() {
    this.nonce = this.parent.dataset.nonce ?? '';

    if (this.script === null) return;
    this.data = JSON.parse(this.script.textContent);
  
    // ---- Structure ----
    this.form.append(this.input_data);
      this.form.insertAdjacentElement('afterbegin', this.div_contact);

        this.div_contact.append(this.h2_contact);

        this.div_contact.append(this.div_firstName);
          this.div_firstName.append(this.label_firstName);
          this.div_firstName.append(this.input_firstName);
          this.div_firstName.append(this.div_firstNameErr);

        this.div_contact.append(this.div_lastName);
          this.div_lastName.append(this.label_lastName);
          this.div_lastName.append(this.input_lastName);
          this.div_lastName.append(this.div_lastNameErr);

        this.div_contact.append(this.div_phone);
          this.div_phone.append(this.label_phone);
          this.div_phone.append(this.input_phone);
          this.div_phone.append(this.div_phoneErr);

        this.div_contact.append(this.div_email);
          this.div_email.append(this.label_email);
          this.div_email.append(this.input_email);
          this.div_email.append(this.div_emailTxt)
          this.div_email.append(this.div_emailErr);
        
        this.div_contact.append(this.div_fun);
          this.div_fun.append(this.label_fun);
          this.div_fun.append(this.select_fun);
            this.select_fun.append(this.option_f0);
            this.select_fun.append(this.option_f1);
            this.select_fun.append(this.option_f2);
            this.select_fun.append(this.option_f3);
            this.select_fun.append(this.option_f4);
            this.select_fun.append(this.option_f5);
            this.select_fun.append(this.option_f6);
          this.div_fun.append(this.div_funErr);

    this.parent.append(this.button_delete);
    this.parent.append(this.p_warning);
    this.parent.append(this.button_cancel);
    this.parent.append(this.button_confirm);

    // ---- Texts ----
    const { __, _x, _n, sprintf } = wp.i18n as i18n;
    this.h2_contact      .textContent = __('Kontakt'        , 'custom');
    this.label_firstName .textContent = __('Vorname'        , 'custom');
    this.label_lastName  .textContent = __('Nachname'       , 'custom');
    this.label_phone     .textContent = __('Telefon'        , 'custom');
    this.label_email     .textContent = __('E-Mail-Adresse' , 'custom');
    this.label_fun       .textContent = __('Funktion'       , 'custom');
    this.option_f0       .textContent = '-- ' + __('Bitte wählen', 'custom') + ' --';
    this.option_f1       .textContent = __('Inhaber'          , 'custom');
    this.option_f2       .textContent = __('Geschäftsleiter'  , 'custom');
    this.option_f3       .textContent = __('Küchenchef'       , 'custom');
    this.option_f4       .textContent = __('Sous-Chef'        , 'custom');
    this.option_f5       .textContent = __('Koch'             , 'custom');
    this.option_f6       .textContent = __('Purchasemanager'  , 'custom');
    this.button_delete   .textContent = __('Konto löschen'    , 'custom');
    this.button_cancel   .textContent = __('Abbrechen'        , 'custom');
    this.button_confirm  .textContent = __('Permanent löschen', 'custom');
    this.p_warning       .textContent = __('Dieser Vorgang kann nicht rückgängig gemacht werden.', 'custom');
    this.div_emailTxt    .textContent = __('Bei einer E-Mail-Änderung wird Ihnen von Grauwiler ein neues Konto aufgesetzt.', 'custom');

    // ---- Classes ----
    this.button_delete .classList.add('c-button-simple-light');
    this.button_confirm.classList.add('c-button-simple-light');
    this.button_cancel .classList.add('c-button-simple');
    this.div_contact   .classList.add('c-div_contact');

    this.css('h2_contact');
    this.css('div_firstName');
    this.css('div_lastName');
    this.css('div_phone');
    this.css('div_fun');
    this.css('div_email');

    this.div_email .style.margin = '0';
    this.div_phone .style.margin = '0';
    this.div_fun   .style.margin = '0';
    
    cUtil.labelIds(this.label_firstName, this.input_firstName);
    cUtil.labelIds(this.label_lastName , this.input_lastName);
    cUtil.labelIds(this.label_phone    , this.input_phone);
    cUtil.labelIds(this.label_fun      , this.select_fun);
    cUtil.labelIds(this.label_email    , this.input_email);

    // ---- Other ----
    this.input_firstName .type = 'text';
    this.input_lastName  .type = 'text';
    this.input_phone     .type = 'text';
    this.input_email     .type = 'email';
    this.button_cancel   .type = 'button';
    this.button_confirm  .type = 'button';
    this.button_delete   .type = 'button';
    this.input_data      .type = 'hidden';
    this.input_email     .autocomplete = 'off';

    this.input_data      .name = 'c-data';

    this.option_f0      .value = 'none';
    this.option_f1      .value = 'Inhaber';
    this.option_f2      .value = 'Geschäftsleiter';
    this.option_f3      .value = 'Küchenchef';
    this.option_f4      .value = 'Sous-Chef';
    this.option_f5      .value = 'Koch';
    this.option_f6      .value = 'Purchasemanager';

    // ---- init ----
    this.p_warning     .classList.add('c-hidden');
    this.button_cancel .classList.add('c-hidden');
    this.button_confirm.classList.add('c-hidden');
    this.fieldset_pw   .classList.add('c-hidden');

    this.div_wcEmail?.classList.add('c-hidden');

    this.input_email.value = this.data.email;
    this.input_phone.value = this.data.phone;
    if( this.data.function === 'none')            this.option_f0.selected = true;
    if( this.data.function === 'Inhaber')         this.option_f1.selected = true;
    if( this.data.function === 'Geschäftsleiter') this.option_f2.selected = true;
    if( this.data.function === 'Küchenchef')      this.option_f3.selected = true;
    if( this.data.function === 'Sous-Chef')       this.option_f4.selected = true;
    if( this.data.function === 'Koch')            this.option_f5.selected = true;
    if( this.data.function === 'Purchasemanager') this.option_f6.selected = true;

    this.input_firstName.value = this.input_wcFirstName.value;
    this.input_lastName .value = this.input_wcLastName .value;

    const v1 = this.validateFirstName();
    const v2 = this.validateLastName();
    const v3 = this.validatePhone();
    const v4 = this.validateFunction();

    // ---- Events ----
    this.button_delete.addEventListener('click', () => {
      this.button_delete .classList.add   ('c-hidden');
      this.p_warning     .classList.remove('c-hidden');
      this.button_cancel .classList.remove('c-hidden');
      this.button_confirm.classList.remove('c-hidden');
    })

    this.button_cancel.addEventListener('click', () =>{
      this.button_delete .classList.remove('c-hidden');
      this.p_warning     .classList.add   ('c-hidden');
      this.button_cancel .classList.add   ('c-hidden');
      this.button_confirm.classList.add   ('c-hidden');
    });

    this.button_confirm.addEventListener('click', async() =>{
      await this.fetch('', 'c_delete_account');
      window.location.href = cUtil.url('/account-deleted/');
    });

    this.button_pw.addEventListener('click', () => {
      this.fieldset_pw.classList.toggle('c-hidden');
    });

    this.button_save.addEventListener('click', (e) => {
      e.preventDefault();
      const v1 = this.validateFirstName();
      const v2 = this.validateLastName();
      const v3 = this.validatePhone();
      const v4 = this.validateFunction();
      const v5 = this.validateEmail();

      if (!(v1 && v2 && v3 && v4 && v5)) return;

      this.input_data.value = JSON.stringify(this.data);
      this.form.submit();
    });

    this.input_email.addEventListener('change', () => {
      this.validateEmail();
    }); 
    this.input_phone.addEventListener('change', () => {
      this.validatePhone();
    }); 
    this.select_fun.addEventListener('change', () => {
      this.validateFunction();
    }); 
    this.input_firstName.addEventListener('change', () => {
      this.validateFirstName();
    }); 
    this.input_lastName.addEventListener('change', () => {
      this.validateLastName();
    }); 
  }

  validateFirstName(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    // Phone
    const value = this.input_firstName.value.trim();
    if (value === '') {
      this.div_firstNameErr .textContent = __('Bitte füllen Sie das Feld aus.', 'custom');
      this.div_firstNameErr .classList.add('c--error');
      this.input_firstName  .classList.add('c--error-marker');
      this.button_save.disabled = true;
      return false;
    }
    else {
      this.div_firstNameErr .textContent = '';
      this.div_firstNameErr .classList.remove('c--error');
      this.input_firstName  .classList.remove('c--error-marker');
      this.input_wcFirstName.value = value;
      this.button_save.disabled = false;
      return true;
    }
  }

  validateLastName(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    // Phone
    const value = this.input_lastName.value.trim();
    if (value === '') {
      this.div_lastNameErr .textContent = __('Bitte füllen Sie das Feld aus.', 'custom');
      this.div_lastNameErr .classList.add('c--error');
      this.input_lastName  .classList.add('c--error-marker');
      this.button_save.disabled = true;
      return false;
    }
    else {
      this.div_lastNameErr .textContent = '';
      this.div_lastNameErr .classList.remove('c--error');
      this.input_lastName  .classList.remove('c--error-marker');
      this.button_save.disabled = true;
      this.input_wcLastName.value = value;
      this.button_save.disabled = false;
      return true;
    }
  }

  validatePhone(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const value = this.input_phone.value.trim();
    if (value === '') {
      this.div_phoneErr .textContent = __('Bitte füllen Sie das Feld aus.', 'custom');
      this.div_phoneErr .classList.add('c--error');
      this.input_phone  .classList.add('c--error-marker');
      this.button_save.disabled = true;
      return false;
    }
    else {
      this.div_phoneErr .textContent = '';
      this.div_phoneErr .classList.remove('c--error');
      this.input_phone  .classList.remove('c--error-marker');
      this.data.phone = value;
      this.button_save.disabled = false;
      return true;
    }
  }

  validateEmail(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    const value   = this.input_email.value.trim();
    const isEmail  = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    const errorMsg =
      this.input_email.value === ''         ? __('Bitte füllen Sie das Feld aus.', 'custom') :
      !isEmail.test(this.input_email.value) ? __('Dies ist keine gültige E-Mail-Adresse.', 'custom') :
      /*else*/ '';

    if (errorMsg !== '') {
      this.div_emailErr .textContent = errorMsg;
      this.div_emailErr .classList.add('c--error');
      this.input_email  .classList.add('c--error-marker');
      this.button_save.disabled = true;
      return false;
    }
    else {
      this.div_emailErr .textContent = '';
      this.div_emailErr .classList.remove('c--error');
      this.input_email  .classList.remove('c--error-marker');
      this.data.email = value;
      this.button_save.disabled = false;
      return true;
    }
  }

  validateFunction(): boolean {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    if (!this.data.managedInStatus) return true;

    // Phone
    const value = this.select_fun.value;
    if (value === 'none') {
      this.div_funErr .textContent = __('Bitte füllen Sie das Feld aus.', 'custom');
      this.div_funErr .classList.add('c--error');
      this.select_fun .classList.add('c--error-marker');
      this.button_save.disabled = true;
      return false;
    }
    else {
      this.div_funErr .textContent = '';
      this.div_funErr .classList.remove('c--error');
      this.select_fun .classList.remove('c--error-marker');
      this.data.function = value;
      this.button_save.disabled = false;
      return true;
    }
  }

  async fetch(data: string, action: string): Promise<string> {
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.nonce);
    formData.append('action'     , action);
    formData.append('data'       , data);
  
    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
    const responseData = await response.json() as string;
    return responseData;
  }

  css<K extends keyof cAccount>(propertyName: K): void {
    const property = this[propertyName];
    if (! (property instanceof HTMLElement)) return;
    property.classList.add(propertyName);
    property.style.gridArea = propertyName;
  }
}
